<template>
  <div>
    <h1>Projektübersicht</h1>
    <h4>Projekte, auf die in den letzten 30 Tagen Stunden geschrieben wurden
      <input type="checkbox" v-model="showActiveProjects" autocomplete="off" />
    </h4>
    <div v-if="projects.length > 0">
      <table class="table">
        <tr>
          <th>Titel</th>
          <th>Archiviert</th>
          <th></th>
        </tr>
        <tr v-for="project in projects" :key="project.id">
          <td>{{ project.title }}</td>
          <td>
            <div v-if="adminAccess">
              <input type="checkbox" v-model="project.archived" @click="updateProjectArchiveStatus(project)">
            </div>
          </td>
          <td>
            <router-link class="btn btn-outline-info"
              :to="{ path: 'projects/ProjectDetails', query: { projectId: project.id } }">Details</router-link>
          </td>
        </tr>
      </table>
      <div>
      </div>
    </div>
    <div v-else>
      Keine Projekte gefunden.
    </div>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
  },
  name: "projects",
  computed: {
      ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
      ...mapState({
        adminAccess: state => state.user.profile.adminAccess,
      }),
    },
  data() {
    return {
      projects: [],
      originalProjectsList: [],
      showActiveProjects: true,
    };
  },
  methods: {
    getActiveProjects() {
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "projects/GetActive" }).then(result => {
        this.originalProjectsList = result.data;
        this.projects = result.data;
      }, error => {
        console.error(error);
      });
    },
    getAllProjects() {
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "projects/GetAllProjects" }).then(result => {
        this.originalProjectsList = result.data;
        this.projects = result.data;
      }, error => {
        console.error(error);
      });
    },
    archiveProject() {
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "projects/GetAllProjects" }).then(result => {
        this.originalProjectsList = result.data;
        this.projects = result.data;
      }, error => {
        console.error(error);
      });
    },
    updateProjectArchiveStatus(project) {
      project.archived = !project.archived;
      axios
        .put(`${process.env.VUE_APP_API_PATH}projects/${project.id}`, project)
        .then(() => console.log(`Project ${project.id} archive status updated`))
        .catch((error) => console.error(error));
    },
  },
  mounted() {

    this.getActiveProjects();

    // Watch for changes to the showActiveProjects checkbox
    this.$watch("showActiveProjects", (flag) => {
      if (flag) {
        this.getActiveProjects();
      } else {
        this.getAllProjects();
      }
    });
    

  }
};


</script>